import { useEffect, useRef, useState } from 'react';
import { cn } from '@/shared/lib/cn';

/**
 * Kırpılan metin için ipucu.
 *
 * `title` HER ZAMAN verilmiyor: sığan bir ad için de ipucu çıkarsa menüde gezinirken
 * her satırın üstünde kutucuk beliriyor ve okunan metni tekrar etmekten başka bir iş
 * görmüyor. Kırpılma ölçülüyor (`scrollWidth > clientWidth`) ve yalnız gerçekten
 * kırpılmışsa başlık yazılıyor — tarayıcının kendi ipucu kullanılıyor, ek bir katman
 * yok (menüde onlarca satır var, her birine bir ipucu bileşeni takmak pahalı).
 *
 * Ölçüm kapsayıcı yeniden boyutlanınca tazeleniyor: kenar çubuğu daraldığında sığan
 * bir ad kırpılır hâle geliyor.
 */
export function TruncatedText({ text, className }: { text: string; className?: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const [clipped, setClipped] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // 1 piksellik pay: alt piksel yuvarlamasında sığan metin de "kırpıldı" görünüyor.
    const measure = () => setClipped(el.scrollWidth > el.clientWidth + 1);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [text]);

  return (
    <span ref={ref} title={clipped ? text : undefined} className={cn('truncate', className)}>
      {text}
    </span>
  );
}
